import React, {useState} from 'react';
import {ReturnTextAndImg} from "../../test/CheckImg";
import {ru} from "../../data/ru";
import {by} from "../../data/by";
import  styleAnswer from './qustions.module.css'
import {rightAnswer} from "./rightAnswer";
import {userAnswer} from "./userAnswer";
const GetQuestionsResult = ({question}) => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdFour : by.RoleIdFour;
    let languageQuestionType =  localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;

    const [isOpenAnswer,setIsOpenAnswer] = useState(false)

    const styleCircle ={right:{backgroundColor:'green'},wrong:{backgroundColor: 'rgba(252, 24, 24, 0.78)'},half:{backgroundColor:'rgba(255, 136, 0, 0.79)'}}
    const styleShadows ={right:{boxShadow:'0 4px 4px rgba(0, 255, 0, 0.5)'},wrong:{boxShadow:'0 4px 4px rgba(252, 24, 24, 0.78)'},half:{boxShadow:'0 4px 4px rgba(255, 136, 0, 0.79)'}}

    function clickQuestionAnswerOpenHandler() {
        setIsOpenAnswer(prev=>!prev)
    }

    const typeName=(type)=> {
        switch (type) {
            case 1:
                return languageQuestionType.choiceOfOneOption;
            case 2:
                return languageQuestionType.multipleChoice;
            case 3:
                return languageQuestionType.longAnswer;
            case 4:
                return languageQuestionType.shortAnswer;
            case 5:
                return languageQuestionType.associations;
            case 6:
                return languageQuestionType.omissionsInTheText;
            case 7:
                return languageQuestionType.sequencing;
            case 8:
                return languageQuestionType.withExplanation;
            case 9:
                return languageQuestionType.transfer;
            case 10:
                return languageQuestionType.table;
            case 11:
                return languageQuestionType.variety;
        }
    }

    const { description, number, score, max_score,is_right,type } = question;

    return (
        <div className={styleAnswer.question}>
            <div className={'student_result_test'} onClick={()=>clickQuestionAnswerOpenHandler()} style={is_right ? (is_right === 1 ? styleShadows.right : styleShadows.half) : styleShadows.wrong}>
               <div className={styleAnswer.headerQuestion}>
                    <div className={styleAnswer.numberQuestion}>
                       <p>{number}</p> <div className={styleAnswer.circle} style={is_right ? (is_right === 1 ? styleCircle.right : styleCircle.half) : styleCircle.wrong} />
                   </div>
                   <p className={styleAnswer.type}>{typeName(type)}</p>
               </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="student_new-task-p">{ReturnTextAndImg(description)}</div>
                    <p className="student_new-task-p">
                        {language.points} {score}/{max_score}
                    </p>
                </div>
                <p className={styleAnswer.footer}>при нажатии открываются ответы</p>
            </div>
            {isOpenAnswer && <div className={styleAnswer.answer}>
                <div>
                    <p>Верный ответ:</p>
                    {rightAnswer(question)}
                </div>
                <div>
                    <p>Ответ пользователя:</p>
                    {userAnswer(question)}
                </div>
            </div>}
        </div>
    );
};

export default GetQuestionsResult;